import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { PatientEducationComponent } from '../patient-education/patient-education.component';
import { ResourcesService } from '../resources.service';

@Component({
    selector: 'app-custom-pagination',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './custom-pagination.component.html',
    styleUrls: ['./custom-pagination.component.scss'],
    standalone: false
})
export class CustomPaginationComponent implements OnInit, OnDestroy {
  @ViewChild(PatientEducationComponent) patEducation: PatientEducationComponent;
  pageRange: any;
  totalOrders: any;
  curPage: any;
  numberOfPages: any;
  pageSize = 18;
  pageSub: Subscription;

  constructor(
    private readonly service: ResourcesService,
    private readonly cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.pageSub = this.service.paginationValues$.subscribe((data) => {
      if (data) {
        this.pageRange = data.pageRange;
        this.totalOrders = data.totalOrders;
        this.curPage = data.curPage;
        this.numberOfPages = data.numberOfPages;
        this.cd.detectChanges();
      }
    });
  }
  ngOnDestroy(): void {
    this.pageSub?.unsubscribe();
  }
  public getCurrentPage(data) {
    this.service.emitPagination(data);
  }
}
